module.exports = __webpack_public_path__ + "media/1x1/ph-6ae85442.svg";